import { KnownSortOrder, ProjectDto, UserDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useCallback } from 'react';
import { createPath, Paths, ProjectPathParams } from '../../../../app/router/app.router';
import { InfiniteQueryUsersListResultDto, UsersListControlsState } from '../../users.queries';
import {
  InfiniteScrollProps,
  InfiniteTable,
  PaginatedRow
} from '../../../../ui/components/pure/list-table-wrappers/infinite-table.component';
import { useUsersTable } from '../hooks/use-users-table.hook';

type UsersTableProps = {
  params: ProjectPathParams<Paths.customers>;
  pages: PaginatedRow<InfiniteQueryUsersListResultDto>[];
  infiniteScroll: InfiniteScrollProps;
  setFormData: (update: Partial<UsersListControlsState>) => void;
  sortData: { sortBy: string; sortOrder: KnownSortOrder };
  isLoading: boolean;
  isPreviousData: boolean;
  hasError: boolean;
};

export function UsersTable({
  params,
  pages,
  infiniteScroll,
  setFormData,
  sortData,
  isLoading,
  isPreviousData,
  hasError
}: UsersTableProps) {
  const tb = useUsersTable(params.projectID);

  const mapRowURL = useCallback(
    (row: { user: UserDto; project?: ProjectDto }) => {
      return row.project
        ? row.project.id === params.projectID
          ? createPath(Paths.customer, {
              projectID: params.shortcode || params.projectID,
              userID: row.user.id
            })
          : createPath(Paths.customerOfChildProject, {
              projectID: params.shortcode || params.projectID,
              userID: row.user.id,
              childProjectID: row.project.id
            })
        : '';
    },
    [params.projectID, params.shortcode]
  );
  tb.config({ mapRowURL });

  return (
    <InfiniteTable
      uniqueKey="user.id"
      onSort={setFormData}
      sortData={sortData}
      table={tb}
      pages={pages}
      infiniteScroll={infiniteScroll}
      isLoading={isLoading}
      isPreviousData={isPreviousData}
      hasError={hasError}
    />
  );
}
